import { v4 as uuid } from 'uuid';
import { Badge, Icon, Spinner } from '@acpaas-ui/react-components';
import { useRef } from 'react';
import Switch from '../../../../components/forms/Switch';
import Tooltip from '../../../../components/core/Tooltip';

const AdminContactsNotApprovedLegend = ({ isFetching, count = 0, error, onToggle, showNotApprovedOnly }) => {
  const tooltipId = useRef(uuid()).current;
  return (
    <div className="spo-m-admin-contacts-legend">
      {isFetching && <Spinner size="small" />}
      {!isFetching && !error && <Badge type="danger">{count}</Badge>}
      {!isFetching && !!error && (
        <span className="u-cursor-help" data-for={tooltipId} data-tip={error}>
          <Icon className="u-text-danger u-margin-left-xs" name="ai-alert-triangle" />
        </span>
      )}

      <span className="u-margin-left-xs">Toon goed te keuren contacten</span>
      <Switch onClick={onToggle} checked={showNotApprovedOnly} />
      <Tooltip id={tooltipId} />
    </div>
  );
};

export default AdminContactsNotApprovedLegend;
